// extracted by mini-css-extract-plugin
export default {"switch_container":"styles_switch_container__ibMcH","item":"styles_item__ZxSDO","isChoiceItem":"styles_isChoiceItem__SbbWy"};